export { MiniState } from './state.class';
export { MiniStore } from './store.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/mini-ngrx/index.js
// module id = ../../../../ngx-bootstrap/mini-ngrx/index.js
// module chunks = 7